// @flow
import { schema } from 'normalizr';


export const school = new schema.Entity('schools');
export const arrayOfSchools = new schema.Array(school);



// WEBPACK FOOTER //
// ./src/scripts/api/schemas/schools.js